<script>
  import {
    ACCEPT_TOS,
    ACCEPT_TOS_INSTRUCTIONS,
    ENTER_YOUR_ACCESS_CODE,
    ACCESS_CODE_INSTRUCTIONS,
    ACCESS_CODE_PRE_GAW,
    ACCESS_CODE_POST_GAW,
    I_AGREE_TO_TOS,
    START_WATCHING,
    TOS,
  } from '../js/l10n/en_US.js';

  import {
    COOKIE_VIEWER_TOKEN,
    ERROR_CRITICAL,
    STREAM_STATUS_UNAVAILABLE_EARLY,
    STREAM_STATUS_UNAVAILABLE_EXPIRED,
  } from '../js/constants.js';

  import { checkAccessCode, clearError, postError } from '../js/actions.js';
  import { formatToShortLocalizedDate } from '../js/libs/datetime.js';
  import { eventState, streamState } from '../js/state.js';
  import Cookies from 'js-cookie';
  import * as moment from 'moment';

  export let source, id, code;

  // handle terms acceptance cookie
  let acceptsTOS = Cookies.get(`acceptsTOS-${id}`) === 'true';

  // checkinTimeout for performing checkin after window has openend
  let checkinTimeout;

  // skipCode should we ask for a code? - no if unrestricted event
  let skipCode;

  // DOM Handlers
  function submitAccessCode() {
    const checkinDelta = 60 * 60 * 1000; // Time before event starts to start checking in

    clearError();
    let doCheckin = false;

    if (!isVodTimeOK()) return;

    if ($eventState && $eventState.start) {
      let timeUntilStart = moment($eventState.start).diff(moment());
      let timeUntilStartDays = moment($eventState.start).diff(moment(), 'days');

      if (timeUntilStartDays < 25) {
        let timeUntilStart = moment($eventState.start).diff(moment());

        if (timeUntilStart < checkinDelta) {
          doCheckin = true;
        } else {
          if (!!checkinTimeout) {
            try {
              clearTimeout(checkinTimeout);
            } catch (e) {
              console.warn('[Access] Access form error', e);
            }
          }
          // checkin 5 seconds after checkin window starts
          checkinTimeout = setTimeout(
            checkAccessCode,
            timeUntilStart - checkinDelta + 5000,
            source,
            id,
            code,
            '',
            true
          );
        }
      }
    }

    checkAccessCode(source, id, code, '', doCheckin);
  }

  function handleChange() {
    Cookies.set(`acceptsTOS-${id}`, acceptsTOS.toString(), {
      sameSite: 'lax',
    });
  }

  function isVodTimeOK() {
    if ($streamState) {
      if ($streamState.state === STREAM_STATUS_UNAVAILABLE_EARLY) {
        let vod_start = moment($streamState.vod.viewing_start);
        // Round up to the nearest minute for display message
        if (vod_start.unix() % 60 != 0) {
          vod_start.add(1, 'minute');
        }
        postError(ACCESS_CODE_PRE_GAW + formatToShortLocalizedDate(vod_start), ERROR_CRITICAL);
        return false;
      } else if ($streamState.state === STREAM_STATUS_UNAVAILABLE_EXPIRED) {
        postError(ACCESS_CODE_POST_GAW, ERROR_CRITICAL);
        return false;
      }
    }
    return true;
  }

  $: skipCode = $streamState && $streamState.unrestricted;

  $: if ($streamState && $streamState.unrestricted && !code) {
    code = 'UNRESTRICTED-' + new Date().getTime();
  }

  $: if ($streamState) isVodTimeOK();
</script>

<div class="container access">
  <h1>{skipCode ? ACCEPT_TOS : ENTER_YOUR_ACCESS_CODE}</h1>
  <p>{skipCode ? ACCEPT_TOS_INSTRUCTIONS : ACCESS_CODE_INSTRUCTIONS}</p>
  <div class="mt-4">
    <form on:submit|preventDefault={submitAccessCode} autocomplete="off">
      <div class="form-group mt-4">
        {#if skipCode}
          <input
            bind:value={code}
            type="hidden"
            class="form-control"
            id="code"
            autocomplete="off"
            aria-label="Access Code" />
        {:else}
          <input
            bind:value={code}
            type="text"
            class="form-control"
            id="code"
            autocomplete="off"
            placeholder={ENTER_YOUR_ACCESS_CODE}
            aria-label="Access Code" />
        {/if}
      </div>
      <div class="form-group mt-4 checkbox">
        <label for="agreed-tos-checkbox">
          <input id="agreed-tos-checkbox" type="checkbox" bind:checked={acceptsTOS} on:change={handleChange} required />
          {I_AGREE_TO_TOS}
          <a target="_blank" href={$eventState && $eventState.terms_link}>{TOS}</a>
        </label>
      </div>
      <div class="form-group mt-4">
        <button
          type="submit"
          class={(skipCode || code) && acceptsTOS ? 'btn text-light' : 'disabled btn text-light'}>
          {START_WATCHING}
        </button>
      </div>
    </form>
  </div>
</div>
